/**
 * Utilidades para trabajar con el SDK de Mercado Pago
 */

let mercadoPagoInstance = null;

/**
 * Inicializa la instancia de Mercado Pago con la clave pública
 * @returns {Promise<MercadoPago>} - Instancia de Mercado Pago
 */
export function initMercadoPago() {
  if (mercadoPagoInstance) {
    return Promise.resolve(mercadoPagoInstance);
  }

  return new Promise((resolve, reject) => {
    // Verificar que el SDK esté cargado
    if (typeof window.MercadoPago === 'undefined') {
      reject(new Error('Mercado Pago SDK no está cargado. Asegúrate de incluir el script en index.html'));
      return;
    }

    const publicKey = window.MERCADOPAGO?.PUBLIC_KEY;

    if (!publicKey) {
      reject(new Error('Clave pública de Mercado Pago no configurada. Configura window.MERCADOPAGO.PUBLIC_KEY en config.js'));
      return;
    }

    try {
      mercadoPagoInstance = new window.MercadoPago(publicKey, {
        locale: 'es-MX',
      });
      resolve(mercadoPagoInstance);
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * Obtiene la instancia de Mercado Pago (inicializa si es necesario)
 * @returns {Promise<MercadoPago>} - Instancia de Mercado Pago
 */
export function getMercadoPagoInstance() {
  return initMercadoPago();
}

/**
 * Convierte payment_type_id de MercadoPago a cardType del backend.
 * @param {string} paymentTypeId - 'credit_card' | 'debit_card'
 * @returns {'C'|'D'}
 */
export function paymentTypeIdToCardType(paymentTypeId) {
  return paymentTypeId === 'debit_card' ? 'D' : 'C';
}
